import { render, staticRenderFns } from "./courseEditorLectureTopic.vue?vue&type=template&id=37a8d3e8&scoped=true&"
import script from "./courseEditorLectureTopic.vue?vue&type=script&lang=js&"
export * from "./courseEditorLectureTopic.vue?vue&type=script&lang=js&"
import style0 from "./courseEditorLectureTopic.vue?vue&type=style&index=0&id=37a8d3e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a8d3e8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandXTransition } from 'vuetify/lib/components/transitions';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VExpandXTransition,VFadeTransition,VHover,VIcon,VSheet})


/* vuetify-loader */
import installDirectives from "!../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
